module.exports = __webpack_public_path__ + "static/media/ju5.4e5f4178.jpg";